/**
 * Hybrid Numeral Component
 * Automatically chooses between Tailwind and styled-components based on props.
 *
 * Routes to styled-components when the consumer uses styled-system props or a
 * styled(Numeral) extension (which injects a `theme` prop); otherwise renders
 * the lighter Tailwind path. Gated on needsStyledComponents — a superset of
 * Button's hasStyledProps gate — so a styled(Numeral) extension reliably hits
 * the SC path, as the ticket's DoD requires.
 */

import * as React from "react";
import { renderNumeral } from "./getNumeral";
import { Container, AbbrContainer } from "./styles"; // Styled-components version
import { NumeralTailwind } from "./NumeralTailwind"; // Tailwind version
import { needsStyledComponents } from "@sproutsocial/seeds-react-system-props";
import type { TypeNumeralProps } from "./NumeralTypes";

const NumeralHybrid = (props: TypeNumeralProps): React.ReactNode => {
  if (needsStyledComponents(props)) {
    return renderNumeral(props, { Container, AbbrContainer });
  }

  // Use Tailwind version (preferred - better performance)
  return NumeralTailwind(props);
};

NumeralHybrid.displayName = "Numeral";
export default NumeralHybrid;
